const ContactCard=({url,title, text})=>
{
    return(
        <div className="sm:mb-[50px] lg:mb-[0px]">
            <img className="w-[32px] h-[32px] sm:mb-[10px] lg:mb-[20px]" src={url}></img>
            <p style={{fontFamil:"Inter"}} className="sm:text-[20px] lg:text-[24px] text-[#F5F5F5] font-[700] leading-[32px] sm:mb-[10px] lg:mb-[15px]">{title}</p>
            {
                title=="Mail Here"?
                <a style={{fontFamil:"Inter"}} href={`mailto:${text}`} className="sm:text-[18px] lg:text-[20px] text-[#F5F5F5] font-[500] leading-[30px] ">{text}</a>:
                <a style={{fontFamil:"Inter"}} href={`tel:${text}`} className="sm:text-[18px] lg:text-[20px] text-[#F5F5F5] font-[500] leading-[30px] ">{text}</a>
            }
            
        </div>
    )
}
export default ContactCard